import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';

export class VariableBenefitSourceJurisdiction implements Deserializable {
  public id!: string;
  public governingJurisdictionId!: GoverningJurisdictionTypeId;
  public governingJurisdiction!: GoverningJurisdictionType | null;
  public desiredLockedStartBalance!: number | null;
  public useEntireLockedBalance!: boolean;
  public desiredUnlockedStartBalance!: number | null;
  public useEntireUnlockedBalance!: boolean;
  public lockedAmountToUnlock!: number | null;
  public lockedPercentageToUnlock!: number | null;
  public availableLockedBalance!: number | null;
  public availableUnlockedBalance!: number | null;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (this.governingJurisdiction) {
      this.governingJurisdiction = Deserialize.instanceOf(GoverningJurisdictionType, this.governingJurisdiction);
    }
  }
}
